import React, { Component } from "react";
import { connect } from "react-redux";
import { actions } from "./redux";
import CSSModules from "react-css-modules";
import ReactHighcharts from "react-highcharts";
import { seriesColor, number, deepClone, units } from "../../../utils";
import styles from "./styles.scss";
import moment from "moment";

let count = 0;
const idPrefix = "LineChart";
const dateFormat = "dddd, MMM Do, h:mm A";

const config = {
   chart: {
      animation: false,
      marginBottom: 85,
		zoomType: 'x',
      panning: true,
      panKey: 'shift',
      style: {
          fontFamily: "Helvetica",
      },
      turboThreshold: 0,
   },
   credits: {
      enabled: false
   },
   colors: seriesColor.getSeriesColors(),
   title: {
      align: "left",
      margin: 60,
      style: {
         color: "#4D4D4D",
         "font-size": "20px",
         "font-weight": "600"
      }
   },
   legend: {
        itemStyle: {
            color: '#999',
            fontWeight: 'normal',
            fontSize: '14px',
        },
        align: 'center',
        verticalAlign: 'bottom',
        layout: 'horizontal',
   },
   tooltip: {
        shared: true,
        formatter: function() {
            var s = '';
    
            this.points.forEach((point, index) => {
                s+= (index > 0 ? '<br />' : '') + '<b><span style="color:' + point.point.color + '">' + moment(point.point.options.timestamp).utc().format(dateFormat) + ':</span></b> ' + (point.point.desc ? ("<br />" + point.point.desc.replace('\n', "<br />").replace('\r', "<br />")) : number.parseNumber(point.y) + ' ' + units.getUnitName(point.point.options.units));
            });
    
            return s;
        }
   },
   xAxis: {
      type: "datetime",
      tickWidth: 0,
      lineColor: "#e6e6e6",
      labels: {
          enabled: false,
      }
   },
   plotOptions: {
       line: {
           dataGrouping: {
               enabled: false,
               groupAll: true,
           },
           turboThreshold: 0,
       },
   },
   yAxis: {
      title: "Run Time",
      labels: {
        formatter() {
        return this.value + " h";
        },
        style: {
            fontSize: "14px",
            color: '#999',
        }
      }
   },
   series: []
};
@CSSModules(styles, { allowMultiple: true })
class ReportChart extends Component {
   render() {
      return <ReactHighcharts config={this.chartConfig} ref={this.chart} isPureConfig={true} />;
   }

   shouldComponentUpdate(nextProps, nextState) {
      if (nextProps.data === this.props.data && nextProps.showing === this.props.showing) {
         return false;
      } else {
         this.teardown();
         return true;
      }
   }

   setup() {
      let chart = this.chart.current.getChart();
      if(chart && this.props.showing) {
         this.props.loadData(this.props.data, chart);
         setTimeout(() => {
            if(chart) {
               chart.reflow();
               chart.redraw();
            }
         }, 100);
      }
   }

   teardown() {}

   componentWillMount() {
      this.chart = React.createRef();
      this.chartConfig = deepClone(config);
   }

   componentDidMount() {
      this.setup();
   }

   componentWillUnmount() {
        if(this.chart.destroy) { this.chart.destroy(); } else { this.chart = null; }
   }

   componentDidUpdate(prevProps, prevState, snapshot) {
      this.setup();
   }
}

const bindAction = dispatch => {
   return {
      loadData: (data, chart) => dispatch(actions.loadData(data, chart))
   };
};

const mapStateToProps = (state, ownProps) => ({});

export default connect(
   mapStateToProps,
   bindAction
)(ReportChart);



// WEBPACK FOOTER //
// ./src/components/EvidenceComponents/ReportChart/ReportChart.js